import React from "react";
import useSettings from "../../../../hooks/settings";
import { lang } from "../../../../middleware/lang";

type StockAction = "disable" | "warn" | "ignore";

const OPTIONS: {
  value: StockAction;
  title: [string, string];
  description: [string, string];
}[] = [
  {
    value: "disable",
    title: ["Desactivar productos (recomendado)", "Disable products (recommended)"],
    description: [
      "Cuando un ingrediente llegue a 0, el producto se marcará automáticamente como agotado. Con esta opción activada, el producto se volverá a activar solo cuando vuelva a haber inventario suficiente. Si eliges cualquier otra opción, tendrás que activarlo manualmente.",
      "When an ingredient reaches 0, the product will automatically be marked as sold out. With this option selected, the product will automatically re-enable itself once there's enough inventory again. If you choose any other option, you'll need to re-enable it manually.",
    ],
  },
  {
    value: "warn",
    title: ["Mostrar advertencia", "Show a warning"],
    description: [
      "Al crear una orden se te avisará si algún producto no tiene inventario suficiente, pero podrás continuar de todas formas.",
      "When creating an order you'll be warned if a product doesn't have enough stock, but you'll still be able to continue.",
    ],
  },
  {
    value: "ignore",
    title: ["No verificar inventario", "Don't check inventory"],
    description: [
      "Los productos se seguirán vendiendo normalmente sin ninguna advertencia ni bloqueo, sin importar el inventario disponible.",
      "Products will keep selling normally with no warning or blocking, regardless of available stock.",
    ],
  },
];

const DEFAULT_ACTION: StockAction = "disable";

const Inventory: React.FC = () => {
  const [settings, saveSettings] = useSettings();
  const currentAction: StockAction =
    (settings.inventory_stock_action as StockAction) || DEFAULT_ACTION;

  const updateAction = (value: StockAction) => {
    saveSettings("inventory_stock_action", value);
  };

  return (
    <div className="row justify-content-start mt-3">
      <div className="col col-md-8">
        <div className="card mb-2">
          <div className="card-body">
            <h4>{lang("Inventario", "Inventory")}</h4>
            <p className="text-muted">
              {lang(
                "Elige qué debe pasar cuando no haya suficiente inventario para preparar un producto.",
                "Choose what should happen when there isn't enough inventory to prepare a product."
              )}
            </p>

            {OPTIONS.map((option) => (
              <div
                key={option.value}
                className="form-group border rounded p-3 mb-3"
              >
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id={`inventory_stock_action_${option.value}`}
                    name="inventory_stock_action"
                    className="custom-control-input"
                    checked={currentAction === option.value}
                    onChange={() => updateAction(option.value)}
                  />
                  <label
                    className="custom-control-label font-weight-bold"
                    htmlFor={`inventory_stock_action_${option.value}`}
                  >
                    {lang(option.title[0], option.title[1])}
                  </label>
                </div>
                <small className="form-text text-muted ml-4 pl-1">
                  {lang(option.description[0], option.description[1])}
                </small>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inventory;
